// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1f1GZ","sendOtp":"AuthorizeToLogin_sendOtp__3wBZo"};